import styled from 'styled-components';

export const StyledMap = styled.div`
  width: 100%;
  height: 100%;
`;

export const PopupContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  touch-action: none;

  &[data-loading='true'] {
    filter: brightness(50%);
  }
`;

export const LoadingOverLay = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;
